import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { LatestUpdate } from '@cigna/chcp/dashboard/data-access';
import { DialogVideoEmbedComponent } from '@cigna/chcp/shared/ui';
import { Subscription, timer } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'cigna-new-features-banner',
  templateUrl: './new-features-banner.component.html',
  styleUrls: ['./new-features-banner.component.scss'],
})
export class NewFeaturesBannerComponent implements AfterViewInit, OnDestroy {
  @Input() features: LatestUpdate[] = [];
  @Input() isLoading = false;

  activeFeatureIndex = 0;
  activeFeatureXCoordPercent = 0;

  timerSubscription: Subscription;
  isRotationPaused = false;

  constructor(public dialog: MatDialog, public sanitizer: DomSanitizer) {}

  ngAfterViewInit(): void {
    this.timerSubscription = timer(10000, 10000)
      .pipe(filter(() => !this.isRotationPaused))
      .subscribe((nextNumber) => {
        this.goToFeature(nextNumber % this.features.length);
      });
  }

  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();
  }

  previousFeature(): void {
    this.goToFeature(Math.max(this.activeFeatureIndex - 1, 0));
  }

  nextFeature(): void {
    this.goToFeature(
      Math.min(this.activeFeatureIndex + 1, this.features.length - 1),
    );
  }

  goToFeature(index: number) {
    this.activeFeatureIndex = index;
    this.activeFeatureXCoordPercent =
      this.calculateActiveFeatureXCoordPercent(index);
  }

  pauseRotation(): void {
    this.isRotationPaused = true;
  }

  resumeRotation(): void {
    this.isRotationPaused = false;
  }

  calculateActiveFeatureXCoordPercent(index: number): number {
    if (index === 0) {
      return 0;
    }
    return -(index / this.features.length) * 100;
  }

  openVideoDialog(feature: LatestUpdate) {
    const videoUrl = new URL(feature.videoUrl as string);
    const playerType: 'youtube' | 'limelight' =
      videoUrl.hostname === 'link.videoplatform.limelight.com'
        ? 'limelight'
        : 'youtube';
    const videoId =
      playerType === 'limelight'
        ? videoUrl.searchParams.get('mediaId')
        : videoUrl.searchParams.get('v');

    this.dialog.open(DialogVideoEmbedComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        title: feature.title,
        id: videoId,
        player: playerType,
        width: 800,
        height: 475,
      },
    });
  }
}
